export const reactsimGrid = `0000000000000000000000000000000000000000000000000000000
0000000000000000000000000000000000000000000000000000000
0011110011111001110001110011111000000111001110100000100
0010001010000010001010001000100000001000100100110001100
0010001010000010001010001000100000001000100100101010100
0010001010000010001010000000100000001000000100100100100
0011110011110010001010000000100011100111000100100000100
0010001010000011111010000000100000000000100100100000100
0010001010000010001010001000100000001000100100100000100
0010001010000010001010001000100000001000100100100000100
0010001011111010001001110000100000000111001110100000100
0000000000000000000000000000000000000000000000000000000
0000000000000000000000000000000000000000000000000000000`
  .split('\n')
  .map(row => row.split('').map(Number));

export const stringToHex = a => arrayToHex(a.split(',').map(Number));
export const arrayToHex = a =>
  `#${a.map(c => c.toString(16).padStart(2, '0')).join('')}`;

export const CETR2 = `0,52,245
0,55,243
0,58,240
0,60,237
0,63,234
0,65,231
0,68,229
0,70,226
0,72,223
0,74,220
0,77,217
0,79,214
0,81,212
0,83,209
0,85,206
0,87,203
0,89,201
0,90,198
0,92,195
0,94,192
0,96,189
0,98,187
0,99,184
0,101,181
0,103,178
0,104,176
0,106,173
0,108,170
0,109,167
0,111,165
0,112,162
0,113,160
0,115,157
0,116,154
0,117,152
1,118,149
8,119,147
14,120,145
20,122,142
24,123,140
28,124,137
32,125,135
35,126,133
38,127,130
41,128,128
43,129,126
45,130,123
47,131,121
49,132,118
51,133,116
52,134,114
53,135,111
55,136,109
56,137,106
57,138,104
58,139,101
59,140,99
59,141,96
60,142,94
61,143,91
61,144,88
62,145,86
62,146,83
62,147,80
63,148,78
63,149,75
63,150,72
63,152,69
63,153,66
63,154,63
63,155,60
63,156,57
63,157,53
63,158,50
63,159,47
63,160,43
63,161,40
64,162,36
64,163,33
65,164,30
66,165,27
68,166,24
70,166,22
72,167,20
74,168,18
77,169,16
79,169,16
82,170,15
85,171,15
87,171,15
90,172,15
93,172,15
96,173,16
98,174,16
101,174,17
104,175,17
106,175,18
109,176,18
111,177,18
114,177,19
116,178,19
119,178,20
121,179,20
124,180,21
126,180,21
129,181,22
131,181,22
133,182,23
136,182,23
138,183,24
140,183,24
143,184,25
145,185,25
147,185,26
150,186,26
152,186,26
154,187,27
156,187,27
159,188,28
161,188,28
163,189,29
165,190,29
168,190,30
170,191,30
172,191,31
174,192,31
176,192,31
179,193,32
181,193,32
183,194,33
185,194,33
187,195,34
190,195,34
192,196,35
194,196,35
196,197,35
198,197,36
200,198,36
203,198,37
205,199,37
207,199,38
209,200,38
211,200,39
213,201,39
215,201,39
218,202,40
220,202,40
222,203,41
224,203,41
226,203,42
228,204,42
230,204,43
232,205,43
234,205,43
236,205,44
238,205,44
240,205,44
242,205,44
244,205,44
245,205,44
246,204,44
248,204,44
249,203,44
249,202,44
250,201,43
251,200,43
251,199,42
252,197,42
252,196,41
252,195,41
252,194,40
253,192,40
253,191,39
253,190,39
253,188,38
253,187,38
253,186,37
254,184,37
254,183,36
254,181,35
254,180,35
254,179,34
254,177,34
254,176,33
254,175,33
255,173,32
255,172,31
255,170,31
255,169,30
255,168,30
255,166,29
255,165,29
255,163,28
255,162,28
255,161,27
255,159,26
255,158,26
255,156,25
255,155,25
255,153,24
255,152,24
255,150,23
255,149,22
255,147,22
255,146,21
255,145,21
255,143,20
255,142,20
255,140,19
255,139,18
255,137,18
255,136,17
255,134,17
255,132,16
255,131,16
255,129,15
255,128,14
255,126,14
255,125,13
255,123,13
255,121,12
255,120,11
255,118,11
255,116,10
255,115,10
255,113,9
255,111,8
255,110,8
255,108,7
255,106,7
255,105,6
255,103,6
255,101,5
255,99,5
255,97,4
255,95,4
255,94,3
255,92,3
255,90,3
255,88,2
254,86,2
254,84,2
254,82,1
254,79,1
254,77,1
254,75,0
254,73,0
254,70,0
254,68,0
253,65,0
253,63,0
253,60,0
253,57,0
253,54,0
253,51,0
253,48,0`
  .split('\n')
  .map(stringToHex);
